/* ====================================================================
   HELPERS —> IS BREAKPOINT
   ==================================================================== */

/**
 * @function isBreakpoint
 * Checks if the current breakpoint matches the passed breakpoint
 * This function supports queries with or without the +/- modifiers
 *
 * Documentation:
 * https://code.area17.com/a17/a17-helpers/wikis/isBreakpoint
 */

import getCurrentMediaQuery from './_getCurrentMediaQuery';

const isBreakpoint = (breakpoint) => {
  /**
   * Return if a breakpoint hasn't been passed as a function parameter
   */

  if (!breakpoint) {
    console.error('No breakpoint has been passed.');
    return false;
  }

  /**
   * Define a regular expression pattern to search for modifiers at the
   * end of a string only
   */

  const pattern = new RegExp('\\+$|\\-$');

  /**
   * Store all breakpoints in an array, ordered smallest to largest
   */

  const breakpoints = ['xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge'];

  /**
   * Store the name of the current breakpoint
   */

  const currentBreakpoint = getCurrentMediaQuery();

  /**
   * Store the index of the current breakpoint
   */

  const currentBreakpointIndex = breakpoints.indexOf(currentBreakpoint);

  /**
   * Check to see if breakpoint has a + or - modifier
   */

  const hasModifier = pattern.exec(breakpoint);

  /**
   * Store the value of the modifier
   */

  const modifier = hasModifier ? hasModifier[0] : false;

  /**
   * Store the breakpoint name excluding any modifiers
   */

  const breakpointName = hasModifier ? breakpoint.slice(0, -1) : breakpoint;

  /**
   * Store the index of the queried breakpoint
   */

  const breakpointIndex = breakpoints.indexOf(breakpointName);

  /**
   * Return if an unrecognised breakpoint has been passed as a
   * function parameter
   */

  if (breakpointIndex < 0) {
    console.warn('Unrecognised breakpoint. Valid breakpoints are: ' + breakpoints.join(', '));
    return false;
  }

  /**
   * Return true if the current breakpoint matches the queried breakpoint
   */

  // eslint-disable-next-line max-len
  if ((modifier === '+' && currentBreakpointIndex >= breakpointIndex) || (modifier === '-' && currentBreakpointIndex <= breakpointIndex) || (!modifier && breakpoint === currentBreakpoint)) {
    return true;
  }

  /**
   * Return false if the current breakpoint does not match the queried breakpoint
   */

  return false;
};

export default isBreakpoint;

